const dinner = [
    {
        id: 1,
        name: 'Spicy beef',
        description: 'spicy beef, potatoes, carrots, cheese sauce, spices',
        price: '17.50'
    },
    {
        id: 2,
        name: 'Spaghetti bolognese',
        description: 'onion, carrot, celery, minced meat, spaghetti, parmesan',
        price: '15.00'
    },
    {
        id: 3,
        name: 'Chickpea curry',
        description: 'onion, chickpea, garlic, mushrooms, tomatoes, spices',
        price: '12.25'
    }
];

export default dinner;